export default "__VITE_ASSET__D3leb7kh__"